// core/infrastructure/services/lead/lead.service.ts

import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment'; // ajustar ruta/nombre si difiere
import { API_CONFIG } from '../../../config/api.config';
import {
  CreateLeadRequest,
  CreateLeadResponse,
} from '../../../domain/interfaces/lead/lead.interface';

@Injectable({ providedIn: 'root' })
export class LeadService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl; 

  createLead(request: CreateLeadRequest): Observable<CreateLeadResponse> {
    return this.http.post<unknown>(
      `${this.baseUrl}${API_CONFIG.ENDPOINTS.CREAR_LEAD}`,
      request,
    ).pipe(map((response) => this.ensureValidCreateLeadResponse(response)));
  }

  // ✅ Actualizar lead existente si ya existe leadId
  updateLead(leadId: string, request: CreateLeadRequest): Observable<CreateLeadResponse> {
    return this.http.put<unknown>(
      `${this.baseUrl}${API_CONFIG.ENDPOINTS.CREAR_LEAD}/${leadId}`,
      request,
    ).pipe(map((response) => this.ensureValidCreateLeadResponse(response)));
  }

  private ensureValidCreateLeadResponse(response: unknown): CreateLeadResponse {
    const candidate = response as {
      data?: {
        holder?: { id?: unknown };
        insured_items?: unknown;
      };
      success?: unknown;
      result?: {
        errors?: Record<string, unknown>;
      };
    } | null;

    const hasData = Boolean(
      candidate?.data
      && candidate.data.holder
      && typeof candidate.data.holder.id === 'string'
      && candidate.data.holder.id.trim()
      && candidate.data.insured_items !== undefined,
    );

    if (hasData) {
      return candidate as CreateLeadResponse;
    }

    const backendError = this.extractBackendErrorMessage(candidate);
    throw new Error(backendError);
  }

  private extractBackendErrorMessage(
    response: {
      success?: unknown;
      result?: { errors?: Record<string, unknown> };
    } | null,
  ): string {
    if (response?.success === false && response.result?.errors) {
      const serializedErrors = JSON.stringify(response.result.errors);
      return `Lead service functional error: ${serializedErrors}`;
    }

    return 'Invalid create lead response payload';
  }
}